import { JSX } from 'react';
import IconButton from '../../../juristec-ui/core/IconButton';
import { NoFileArch, Add } from '../../../juristec-ui/icons';
import { StyledNoFile, StyledOuterNoFile } from './styled/NoFiles.styled';

const systemMap = () => {
  switch (process.env.REACT_APP_FIREBASE_PROJECT_LABEL) {
    case 'legalone-analytics':
      return 'Legal One Analytics';
    case 'benner-metrics':
      return 'Benner Metrics';
    case 'legalmetrics':
      return 'Legal Metrics';
    default:
      return 'Sistema';
  }
};

interface NoFilesProps {
  typeMsg?: string;
  toggle?: () => void;
}

const NoFiles = ({
  toggle = () => {}, typeMsg = 'empty',
}: NoFilesProps): JSX.Element => (
  <StyledOuterNoFile>
    <StyledNoFile>
      <div className="content">
        {typeMsg !== 'empty' ? (
          <>

            <p className="firstphrase">
              <b>Nenhum arquivo criado!</b>
              <br />
              Faça upload de um arquivo
              {' '}
              <b>.csv ou .xlsx</b>
              {' '}
              no botão
              {' '}
              <IconButton
                onClick={toggle}
                color="secondary"
                variant="contained"
                shape="rounded"
              >
                <Add />
              </IconButton>
              {' '}
              no canto superior direito para ter acesso a todos os recursos do
              {' '}
              {systemMap()}
              .
            </p>
          </>
        ) : (
          <p>
            <b>Nenhum arquivo encontrado!</b>
            {' '}
            <br />
            {' '}
            Tente outro nome de arquivo.
          </p>
        )}
        <NoFileArch />
      </div>

    </StyledNoFile>
  </StyledOuterNoFile>
);

export default NoFiles;
